import { React, useState } from 'react';
import { Tooltip } from 'antd';
import { useHistory } from 'react-router-dom';
import { Card, Col, Row, Empty } from 'antd';
import { FolderOutlined } from '@ant-design/icons';
import '@/style/PilotView.css';
import { useSelector } from 'react-redux';
import { selectAuth } from '@/redux/auth/selectors';
import cryptoHelper from '@/utils/crypto';

const PilotView = ({ initiatives }) => {
  const history = useHistory();
  const currentUser = useSelector(selectAuth);
  const [hoveredInitiative, setHoveredInitiative] = useState(null);

  const myInitiatives =
    initiatives &&
    initiatives.filter((item) => {
      // Truncate long initiative names
      if (item.initiativeName?.length > 40) {
        item.initiativeName = item.initiativeName.substring(0, 40) + '...';
      }
      if (currentUser?.hasSpecialAccess === true) {
        return true;
      }
      // Check if current user has access
      const isOwner = item.initiativeOwnerInfo?.[0]?._id === currentUser.id;
      const isBackupOwner = item.initiativeOwnerBackupInfo?.[0]?._id === currentUser.id;
      const isWorkstreamLead = item.workstreamLeadInfo?.[0]?._id === currentUser.id;
      const isWorkstreamSponsor = item.workstreamSponsorInfo?.[0]?._id === currentUser.id;
      const isAllowedUser = item.AllowOnlyTo?.some(
        (allowedUser) => allowedUser._id === currentUser.id
      );
      // const isMilestoneOwner = item.milestones?.some(
      //   (milestone) => milestone.Owner === currentUser.id
      // );

      const isAdminRole =
        currentUser.role.name === 'CTO' ||
        currentUser.role.name === 'TO Finance' ||
        currentUser.role.name === 'Strategy Analyst' ||
        currentUser.role.name === 'Admin';

      const hasAccess =
        isOwner ||
        isBackupOwner ||
        isWorkstreamLead ||
        isWorkstreamSponsor ||
        isAllowedUser ||
        // isMilestoneOwner ||
        isAdminRole;
      return hasAccess;
    });

  const handleClick = (initiativeId) => {
    const encryptedId = cryptoHelper.encrypt(initiativeId);
    const encodedData = encryptedId.replace(/\//g, '_');
    history.push(`/initiative/update/${encodedData}`);
  };

  const handleMouseEnter = (initiative) => {
    setHoveredInitiative(initiative);
  };

  const handleMouseLeave = () => {
    setHoveredInitiative(null);
  };

  return (
    <div className="pilot-container">
      {myInitiatives.length === 0 ? (
        <Empty description="No Initiatives Found" className="empty-state" />
      ) : (
        <Row gutter={[16, 16]} justify="start">
          {myInitiatives.map((initiative) => (
            <Col key={initiative._id} xs={24} sm={12} md={8} lg={6} xl={4}>
              <Card
                className="pilot-card"
                hoverable
                onClick={() => handleClick(initiative._id)}
                onMouseEnter={() => handleMouseEnter(initiative)}
                onMouseLeave={handleMouseLeave}
              >
                <div className="initiative-header">
                  <FolderOutlined className="folder-icon" style={{ color: 'blue' }} />
                  <span className="initiative-number">#{initiative.initiativeNumber}</span>
                </div>
                <Tooltip
                  title={
                    hoveredInitiative && hoveredInitiative._id === initiative._id
                      ? initiative.initiativeName
                      : ''
                  }
                  placement="top"
                >
                  <div className="initiative-title">{initiative.initiativeName}</div>
                </Tooltip>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default PilotView;
